import templateUrl from 'emun.order/notes/note-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import NotePrompt from "emun.order/notes/note-prompt"

class NoteListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryNotes.json',
			autoLoad: true,
			hideLeftNav: true
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("noteSaved", () => $ctrl.query.load(true));
    }
	create() {
		const $ctrl = this;
		NotePrompt.open({ note: "", noteId: "" });
	}

	edit(note) {
		const $ctrl = this;
		NotePrompt.open({ note: note, noteId: note.id });
	}

	delete(note) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete this note", "Delete Note?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteNote.json", note)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let NoteList = {
	controller: NoteListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default NoteList;
